import type { IMetadataRepository, MetadataUpdateInput } from '../repositories/IMetadataRepository.js';
import type { MetadataEntity } from '../entities/MetadataEntity.js';

export interface UpdateMetadataInput { id: string; data: MetadataUpdateInput; }
interface Deps { metadataRepository: IMetadataRepository; }
export function createUpdateMetadataUseCase({ metadataRepository }: Deps) {
  return async function updateMetadata({ id, data }: UpdateMetadataInput): Promise<MetadataEntity | null> {
    return metadataRepository.update(id, data);
  };
}
